import axios from "../axiosConfig";
import { ENDPOINT_INVITE, ENDPOINT_INVITE_ACCEPT, ENDPOINT_INVITE_DETAILS, ENDPOINT_REG } from "../../constants";

export type AppRole = {
    app:string
    roles:string[]
}

export function inviteAccept(code:string,email:string) : Promise<string> {
    return new Promise<string>( async (resolve, reject) => {
        axios.post(ENDPOINT_INVITE_ACCEPT, {
            access_code: code, 
            email: email,
        }).then( res => {
            console.log(res.data)
            resolve( res.data.Code)
        })
        .catch( (err) => {
            console.log(err)
            reject(err)
        });
    })
}

export function register(data:{}): Promise<string> {
    return new Promise<any>( async (resolve, reject) => {
        axios.post(ENDPOINT_REG, data).then( res => {
            console.log(res.data)
            resolve(res.data.Code)
        })
        .catch( (err) => {
            console.log(err)
            reject(err)
        });
    })
}

export function inviteUser(email:string,roles:AppRole[]): Promise<any> {
    return new Promise<any>( async (resolve, reject) => {
        axios.post(ENDPOINT_INVITE, {
            email:btoa(email),
            roles:roles,
        }, {withCredentials:true}).then( res => {
            console.log(res.data)
            resolve(res.data)
        })
        .catch( (err) => {
            console.log(err)
            reject(err)
        });
    })
}

export function inviteDetails(email:string,accesscode:string): Promise<any> {
    return new Promise<any>( async (resolve, reject) => {
        axios.get(ENDPOINT_INVITE_DETAILS + "?email="+email+"&access="+accesscode, 
            {withCredentials:true}).then( res => {
            console.log(res.data)
            resolve(res.data)
        })
        .catch( (err) => {
            console.log(err)
            reject(err)
        });
    })
}
